/* eslint-disable react/prop-types */
import React from 'react'
import { IndexPage } from './pages/IndexPage'
import './App.css'

function App() {
  return (
    <div className="App">
      <main>
        <IndexPage />
      </main>
    </div>
  )
}

export default App
